const themePageLevelBaseProps = theme => (theme ? { themeName: theme.title } : {});

export default themePageLevelBaseProps;
